// 创建一个新的工具文件来处理token和登录状态

// token过期时间(毫秒) - 30天
const TOKEN_EXPIRE_TIME = 30 * 24 * 60 * 60 * 1000; 

// 设置token和最后活动时间
export function setToken(token) {
  const now = Date.now();
  localStorage.setItem('token', token);
  localStorage.setItem('lastActivityTime', now.toString());
  localStorage.setItem('loginTime', now.toString()); // 添加登录时间
  // 启动自动检查
  startAutoCheck();
}

// 添加自动检查功能
let autoCheckTimer = null;

function startAutoCheck() {
  // 清除可能存在的旧定时器
  if (autoCheckTimer) {
    clearInterval(autoCheckTimer);
  }
  
  // 每10秒检查一次token状态
  autoCheckTimer = setInterval(() => {
    const status = checkTokenExpiration();
    if (status.expired) {
      clearLoginInfo();
      clearInterval(autoCheckTimer);
      // 如果在Vue实例中，可以通过事件总线触发登出事件
      if (window._vue) {
        window._vue.$bus.$emit('tokenExpired', status.message);
      }
    }
  }, 10000);
}

// 设置用户信息
export function setUserInfo(userInfo) {
  localStorage.setItem('userInfo', JSON.stringify(userInfo));
}

// 检查token是否过期
export function checkTokenExpiration() {
  const lastActivityTime = localStorage.getItem('lastActivityTime');
  const loginTime = localStorage.getItem('loginTime');
  const token = localStorage.getItem('token');

  if (!token) {
    return {
      expired: true,
      message: '登录已过期，请重新登录'
    };
  }

  if (lastActivityTime && loginTime) {
    const currentTime = Date.now();
    const lastActivity = parseInt(lastActivityTime);
    const loginTimeStamp = parseInt(loginTime);
    
    // 检查是否超过30分钟没有活动
    const inactiveTime = currentTime - lastActivity;
    // 检查距离首次登录是否超过30分钟
    const totalLoginTime = currentTime - loginTimeStamp;

    if (inactiveTime > TOKEN_EXPIRE_TIME || totalLoginTime > TOKEN_EXPIRE_TIME) {
      // token过期，清除登录信息
      clearLoginInfo();
      return {
        expired: true,
        message: '登录已过期，请重新登录'
      };
    }
    
    // 更新最后活动时间
    localStorage.setItem('lastActivityTime', currentTime.toString());
    return {
      expired: false
    };
  }

  // 如果没有最后活动时间或登录时间，认为未登录
  clearLoginInfo();
  return {
    expired: true,
    message: '未登录，请先登录'
  };
}

// 清除登录信息
export function clearLoginInfo() {
  localStorage.removeItem('token');
  localStorage.removeItem('userInfo');
  localStorage.removeItem('lastActivityTime');
  localStorage.removeItem('loginTime');
  // 清除定时器
  if (autoCheckTimer) {
    clearInterval(autoCheckTimer);
  }
}

// 更新最后活动时间
export function updateLastActivityTime() {
  const currentTime = Date.now();
  const loginTime = localStorage.getItem('loginTime');
  
  // 如果距离首次登录时间超过30分钟，则清除登录信息
  if (loginTime && (currentTime - parseInt(loginTime) > TOKEN_EXPIRE_TIME)) {
    clearLoginInfo();
    return false;
  }
  
  localStorage.setItem('lastActivityTime', currentTime.toString());
  return true;
} 